// extracted by mini-css-extract-plugin
module.exports = {"paymentsCountTag":"style_paymentsCountTag__439eY","interestText":"style_interestText__9kJOP","downPaymentText":"style_downPaymentText__eR7kF"};